<template>
  <div class="cloudChain">
    <div class="one1"></div>
    <div class="one2">正在努力开发中，敬请期待！</div>
  </div>
</template>

<script>
export default {
    name: '',
    props: {
      
    },
    data(){
      return{

      }
    }
}
</script>

<style scoped>
  .one1{width: 100%;height: 4.5rem;background: #031138;}
    .one2{width: 100%;height: 100rem;display: flex;justify-content: center;align-items: center;}
</style>
